import RestApiClient from './RestApiClient';
import { buildHeaders,generateUrlApiV2 } from '../helpers/MiddlewareHelpers';
import axios from 'axios';

const trackApiCall = (idCompetition, parameters, successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/event/${idCompetition}`,
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const trackClickApiCall = (idCompetition, parameters, successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/event/${idCompetition}/click`,
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const optinApi = (parameters, token, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/optin',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters,
        authenticated: true,
        token: token
    });
}

const optinSocialApi = (parameters, token, successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/terms`,
        type: 'PUT',
        successCallback,
        catchCallback,
        payload: parameters,
        authenticated: true,
        token: token
    });
}

const loginFace = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/facelogin',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const retrieveTwitterAccessToken = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/twitter/login',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}


const retrieveTwitterToken = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: `/twitter/requesttoken/${parameters.idCompetition}`,
        type: 'GET',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const login = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/login',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const logoff = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/login', // TODO: replace by token invalidation endpoint
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const register = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/registerlogin',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const forgotCall = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/recover',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const resetCall = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/reset',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const emailConfirmation = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/confirmation',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const getActiveCompetitions = (hash, successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/competition/hash/${hash.replace(/\//g, "_")}`,
        type: 'GET',
        successCallback,
        catchCallback
    });
}

const getAcceptedImageListApi = (hash, data, successCallback, catchCallback) => {

    if (!data || data.page < 0 || !data.limit) {
        return false;
    }

    let callUrl = `/competition/getImageUploadList/${hash}?page=${data.page}&limit=${data.limit}`;

    if (data.filter && data.filter != '') {
        callUrl += `&filter=${data.filter}`;
    }
    if (data.sort && data.sort != '') {
        callUrl += `&sort=${data.sort}`;
    } else {
        callUrl += `&sort=random`;
    }

    RestApiClient({
        apiV2: true,
        relativeUrl: callUrl,
        type: 'GET',
        successCallback,
        catchCallback
    });
}

const getAwsTokens = (successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/competition/hash`,
        type: 'GET',
        successCallback,
        catchCallback
    });
}

const getLeaderboardsApi = (successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/leaderboards',
        type: 'GET',
        successCallback,
        catchCallback
    });
}

const submit = (parameters, token, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/vote/leaderboard',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters,
        authenticated: true,
        token: token
    });
}

const submitImage = (parameters, successCallback, catchCallback) => {
    RestApiClient({
        apiV2: true,
        relativeUrl: '/image-upload/create',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters,
        authenticated: true
    });
}

const reValidateToken = (parameters, successCallback, catchCallback) => {
    RestApiClient({
        relativeUrl: '/revalidate',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const getLanguageApiCall = (language,successCallback,catchCallBack)=>{
    const headers = buildHeaders();
    const url = generateUrlApiV2('/locale/getLocaleData/'+language);
    axios.get(url,{
        method:'GET',
        crossdomain:true,
        headers:headers,
    }).then(successCallback).catch(catchCallBack);
}

const webhookRegisterApi = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/competition/${parameters.idCompetition}/registerWebhook`,
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const getGlobalScriptsForCustomerApi = (hash, successCallback, catchCallback) => {
    RestApiClient({
        apiV2: true,
        relativeUrl: `/customer/getCodeInjectionForCustomer/${hash.replace(/\//g, "_")}`,
        type: 'GET',
        successCallback,
        catchCallback
    });
}

const updateVBPInnerApi = (idCompetition, data, successCallback, catchCallback) => {
    RestApiClient({
        apiV2: true,
        relativeUrl: `/competition/${idCompetition}/optinVB`,
        type: 'POST',
        successCallback,
        authenticated: true,
        catchCallback,
        payload: data
    });
}

export {
    login, loginFace, retrieveTwitterToken,
    retrieveTwitterAccessToken,
    logoff, register, emailConfirmation,
    getActiveCompetitions, submit, getLeaderboardsApi,
    reValidateToken, forgotCall, resetCall, optinApi,
    optinSocialApi,
    trackApiCall, trackClickApiCall,
    getAwsTokens,
    submitImage,
    getLanguageApiCall,
    getAcceptedImageListApi, webhookRegisterApi,
    getGlobalScriptsForCustomerApi, updateVBPInnerApi
}
